/** The prototype's `--sbw` (subscription-portal.html): the OS scrollbar's
 * width, measured once on a throwaway scrolling box and set on `<html>`.
 * PageScrollArea always reserves a scrollbar gutter, so its cards pull back
 * into the gutter by this much to line up with the header and tabs above, and
 * the User Limits list takes it back out of its right padding. Overlay
 * scrollbars (macOS default) measure 0, which makes both a no-op. */
export function measureScrollbarWidth(doc: Document = document): number {
  const probe = doc.createElement('div')
  probe.style.cssText = 'position:absolute;top:-9999px;width:100px;height:100px;overflow:scroll'
  doc.body.appendChild(probe)
  const width = Math.max(0, probe.offsetWidth - probe.clientWidth)
  probe.remove()
  doc.documentElement.style.setProperty('--sbw', `${width}px`)
  return width
}
